<template>
  <v-data-table
    class="no-border"
    :items="getScheduledPreparations.filter(x => x.is_done === false)"
    :headers="headers"
    :items-per-page="itemPerPage"
    dense
    :mobile-breakpoint="0"
    hide-default-footer
    hide-default-header
    :loading="loading"
    sort-by="date"
    :sort-desc="false"
  >
    <template v-slot:item="{ item }">
      <tr>
        <td width="140">
          <span class="caption">{{ item.date | dateLocalFormat }}</span>
        </td>
        <td>
          <span class="caption" style="text-transform: capitalize;">{{
            getName(item)
          }}</span>
        </td>
        <td>
          <div v-if="item.quantity !== null">
            <span>{{ item.quantity | round2 }}</span>
            <span class="caption ml-1">{{ getUnit(item) }}</span>
          </div>
        </td>
        <td width="75">
          <v-row align="center" justify="end" no-gutters>
            <Prompt
              v-if="isSame(item)"
              type="number"
              submitText="Confimer la préparation"
              activator-size="small"
              activator-icon-size="small"
              activator-icon="fa-clipboard-check"
              color="success"
              inputText="Quantité produite"
              :initialValue="item.quantity"
              @submit="v => comfirmPreparation(item, v)"
            >
            </Prompt>
            <ScheduledPrepEditor icon :id="item.id"></ScheduledPrepEditor>
          </v-row>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { api } from "@/api";
import ScheduledPrepEditor from "./ScheduledPrepEditor";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "ScheduledPrepGrid",
  components: {
    ScheduledPrepEditor
  },
  props: {
    itemPerPage: {
      type: Number,
      default: 5
    }
  },
  created() {
    this.getData();
  },
  computed: {
    ...mapGetters(["getScheduledPreparations", "getRecipes"])
  },
  data() {
    return {
      loading: false,
      now: moment(),
      headers: [
        { value: "date", width: 130 },
        { value: "fk_recipe" },
        { value: "quantity", width: 100 },
        { value: "actions", width: 75 }
      ]
    };
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        await this.$store.dispatch("loadScheduledPreparations");
      } finally {
        this.loading = false;
      }
    },
    getName(item) {
      const r = this.getRecipes.find(x => x.id === item.fk_recipe);
      return r ? r.nom : "";
    },
    getUnit(item) {
      const r = this.getRecipes.find(x => x.id === item.fk_recipe);
      return r && r.data ? r.data.unite_inventory : "";
    },
    isSame(item) {
      const now = moment();
      return moment(item.date).isSameOrBefore(now, "day");
    },
    async comfirmPreparation(item, value) {
      if (value !== null) {
        const tasks = [];
        const prepData = {
          ...item,
          is_done: true
        };
        tasks.push(
          this.$store.dispatch("updateScheduledPreparation", prepData)
        );
        const r = this.getRecipes.find(x => x.id === item.fk_recipe);
        if (r) {
          const trasactionData = {
            id: r.fk_produit_intermediaire,
            quantity: value
          };
          tasks.push(api.postProduction(trasactionData));
        }
        await Promise.all(tasks);
        this.$store.dispatch("loadInventoryRecords", {
          store: this.getStoreId,
          latest: true
        });
      }
    }
  }
};
</script>

<style></style>
